import fp from 'lodash/fp';

export const updateResourceState = (state, resource, newState) => ({
  ...state,
  [resource]: {
    ...fp.get(resource, state),
    ...newState
  }
});


// WEBPACK FOOTER //
// ./src/state/modules/quiz/configurations/util.js